import AuthField from 'components/Fields/AuthField'
import {Field, reduxForm} from 'redux-form'

const validate = values => {
  const errors = {}
  if (!values.email) {
    errors.email = 'The email address is required'
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Please enter a valid email address'
  }
  return errors
}

class ResendVerificationEmailForm extends React.Component {
  render () {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <Field
          component={AuthField}
          name='email'
          type='text'
          placeholder='Email'
          autoCorrect='off'
          autoCapitalize='off'
          icon='fa fa-envelope-o'
          spellCheck='false' />
        <button type='submit' className='btn btn-primary btn-block'>Resend</button>
      </form>
    )
  }
}

ResendVerificationEmailForm.propTypes = {
  handleSubmit: React.PropTypes.func
}

export default reduxForm({
  form: 'resendVerificationEmail',
  touchOnBlur: false,
  touchOnChange: true,
  validate
})(ResendVerificationEmailForm)



// WEBPACK FOOTER //
// ./app/pages/ResendVerificationEmail/ResendVerificationEmailForm.js